import React from "react";

const SUBTOPIC_COLORS = ["#EF4444", "#14B8A6", "#F59E0B", "#8B5CF6", "#EC4899"];

interface SubtopicSelectorProps {
  subtopics: string[];
  selectedSubtopic: string | null;
  handleSubtopicSelect: (subtopic: string | null) => void;
  isVertical?: boolean;
}

const SubtopicSelector: React.FC<SubtopicSelectorProps> = ({
  subtopics,
  selectedSubtopic,
  handleSubtopicSelect,
  isVertical = false
}) => {
  if (!subtopics || subtopics.length === 0) return null;

  const hasAll = subtopics[0] === "All";

  return (
    <div className={`flex ${isVertical ? "flex-col w-64 p-4 border-r border-[rgba(48,48,48,0.1)] h-full" : "flex-row mb-8 flex-wrap items-center"}`}>
      {subtopics.map((subtopic, index) => {
        const colorIndex = hasAll ? Math.max(0, index - 1) : index;
        const isActive = selectedSubtopic === subtopic;
        return (
          <div
            key={subtopic}
            className={`px-4 py-2 rounded-md text-[#111] text-sm font-medium cursor-pointer flex items-center gap-2 transition-all duration-200 ${isActive ? "bg-[#C2B7FA] hover:bg-[#B2A2F5]" : "bg-transparent hover:bg-[#F3F4F6]"
              } ${isVertical ? "mb-1 w-full" : ""}`}
            onClick={() => handleSubtopicSelect(subtopic)}
          >
            {subtopic !== "All" && (
              <div
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: SUBTOPIC_COLORS[colorIndex % SUBTOPIC_COLORS.length] }}>
              </div>
            )}
            {subtopic}
          </div>
        );
      })}
    </div>
  );
};

export default SubtopicSelector;
